import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CreatableSelect from 'react-select/creatable';

import CustomDropdown from '@components/CustomDropdown';
import ModalContainer from '@components/modals/ModalContainer';
import { toastSuccess } from '@components/Toast';

import UploadFiles from '@features/assets/components/CommonComponents/UploadFiles';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { getMarkets as fetchAllMarkets, getSubCategories as fetchAllCategories } from '@store/design/action';
import { getAllMarkets, getAllSubCategories, getAllTags } from '@store/reducers';
import { fetchAllTags } from '@store/supplier/action';

import { onAddSketch, onUpdateSketch } from '@services/assetsService';

const AddSketchModal = ({ sketchResponse, saveType, onCloseModal, seketchId, onActionSucces }) => {
	const [isLoading, setIsloading] = useState(false);
	const [searchTerm] = useState('');
	const [selectedListType, setSelectedListType] = useState('PRODUCT_FITTING_TYPE');
	const [selectedSketchResponse, setSelectedSketchResponse] = useState(null);
	const [multipleImageData, setMultipleImageData] = useState([]);
	const [allFilesAndImages, setAllFilesAndImages] = useState([]);
	const [documentIds, setDocumentIds] = useState([]);
	const [error, setError] = useState(false);
	const dispatch = useDispatch();

	const defaultSketchResponse = {
		documentResponseList: [],
		fittingTypeTagResponse: null,
		riseTagResponse: null,
		lengthTagResponse: null,
		marketResponse: null,
		categoryResponse: null,
		inspiredFrom: '',
		tagResponseList: [],
		remarks: ''
	};

	useEffect(() => {
		if (saveType === 'add') {
			setSelectedSketchResponse(defaultSketchResponse);
		} else {
			const formattedSketchResponse = {
				...sketchResponse,
				tagResponseList: sketchResponse?.tagResponseList?.map((tag) => ({
					id: tag.id,
					text: tag.text
				}))
			};
			setSelectedSketchResponse(formattedSketchResponse || defaultSketchResponse);
		}
	}, [sketchResponse, saveType]);

	useEffect(() => {
		if (saveType === 'edit' && selectedSketchResponse?.documentResponseList?.length !== 0) {
			setAllFilesAndImages(selectedSketchResponse?.documentResponseList);
			let alldocumentIds = selectedSketchResponse?.documentResponseList?.map((item) => item.id);
			setDocumentIds(alldocumentIds);
		} else {
			setAllFilesAndImages([]);
		}
	}, [selectedSketchResponse]);

	let allMarkets = useSelector(getAllMarkets)?.map((item) => {
		return {
			id: item.id,
			value: item.name
		};
	});

	let allCategories = useSelector(getAllSubCategories)?.map((item) => {
		return {
			id: item.id,
			value: item.name
		};
	});

	let allTags = useSelector(getAllTags)?.allTags?.map((item) => {
		return {
			value: item.id,
			label: item.text
		};
	});

	let allOtherTags = useSelector(getAllTags)?.allTags?.map((item) => {
		return {
			id: item.id,
			value: item.text
		};
	});

	const onTagsChange = (selected) => {
		let tags = selected.map((item) => {
			if (item.value === item.label) {
				return {
					text: item.label ?? item.text
				};
			} else {
				return {
					id: item.value ?? item.id,
					text: item.label ?? item.text
				};
			}
		});
		setSelectedSketchResponse({ ...selectedSketchResponse, tagResponseList: tags });
	};

	const onAddListType = (value, type) => {
		let selectedItem =
			type === 'MARKET' || type === 'CATEGORY' ? { name: value.value } : { text: value.value };

		if (value?.id) {
			selectedItem['id'] = value.id;
		}

		const updateMap = {
			PRODUCT_FITTING_TYPE: 'fittingTypeTagResponse',
			MARKET: 'marketResponse',
			CATEGORY: 'categoryResponse',
			PRODUCT_LENGTH: 'lengthTagResponse',
			PRODUCT_RISE: 'riseTagResponse'
		};

		setSelectedSketchResponse({ ...selectedSketchResponse, [updateMap[type]]: selectedItem });
	};

	const handleMultipleImageDataChange = (imageData) => {
		setMultipleImageData(imageData);
	};

	const validateForm = () => {
		let cloneError = {};
		if (!selectedSketchResponse?.marketResponse) {
			cloneError.market = 'Field is required';
		}
		if (!selectedSketchResponse?.categoryResponse) {
			cloneError.category = 'Field is required';
		}
		if (!selectedSketchResponse?.fittingTypeTagResponse) {
			cloneError.fittingTypeTag = 'Field is required';
		}

		const firstImage = multipleImageData.find((img) => img.docType === 'ASSETS_IMAGE_S1');
		if (!firstImage) {
			cloneError.image = 'Front image is required.';
		}

		setError(cloneError);
		return Object.keys(cloneError).filter((key) => cloneError[key] !== undefined).length > 0;
	};

	const handleImageIdsChange = (ids) => {
		setDocumentIds(ids);
	};

	const onSubmit = async () => {
		if (!validateForm()) {
			let body = {
				marketId: selectedSketchResponse?.marketResponse?.id,
				categoryId: selectedSketchResponse?.categoryResponse?.id,
				inspiredFrom: selectedSketchResponse?.inspiredFrom,
				remarks: selectedSketchResponse?.remarks,
				fittingTypeTag: selectedSketchResponse?.fittingTypeTagResponse,
				riseTag: selectedSketchResponse?.riseTagResponse,
				lengthTag: selectedSketchResponse?.lengthTagResponse,
				documentIds: documentIds,
				tags: selectedSketchResponse?.tagResponseList
			};
			try {
				dispatch(openLoader());
				const responseData =
					saveType === 'edit' ? await onUpdateSketch(body, seketchId) : await onAddSketch(body);
				onActionSucces(responseData);
				toastSuccess('Successfully updated');
				dispatch(closeLoader());
				onCloseModal();
			} catch {
				dispatch(closeLoader());
			}
		}
	};

	useEffect(() => {
		setIsloading(true);
		dispatch(fetchAllTags(searchTerm, selectedListType)).finally(() => {
			setIsloading(false);
		});
	}, [searchTerm, selectedListType]);

	useEffect(() => {
		dispatch(fetchAllMarkets());
		dispatch(fetchAllCategories());
	}, []);

	return (
		<ModalContainer className="add-Sketch-modal" onCloseModal={() => {}}>
			<div className="common-popup add-Sketch-modal">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte d-flex align-items-center">
						<h3 className="semibold-16 mb-0">{saveType === 'edit' ? 'Edit' : 'Add'} Sketch</h3>
					</div>
					<div className="close-btn" onClick={onCloseModal}>
						<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
					</div>
				</div>
				<div className="common-popup-body scroll-y-label">
					<UploadFiles
						type="SKETCH"
						itemId={selectedSketchResponse?.id || null}
						onImageIdsChange={handleImageIdsChange}
						onMultipleImageDataChange={handleMultipleImageDataChange}
						allFilesAndImages={allFilesAndImages}
						error={error.image}
					/>
					{/* {error.image && <p className="error">{error.image}</p>} */}
					<div className="pom-form">
						<div className="row">
							<div className="col-md-4 pr-2">
								<div className="form-group">
									<label htmlFor="collection">Market*</label>
									<CustomDropdown
										isLoading={isLoading}
										isShowLabel={false}
										toolTipLength={18}
										items={allMarkets}
										selectedItem={selectedSketchResponse?.marketResponse?.name}
										onItemClick={(value) => onAddListType(value, 'MARKET')}
									/>{' '}
									{error.market && <p className="error">{error.market}</p>}
								</div>
							</div>
							<div className="col-md-4 pr-2">
								<div className="form-group">
									<label htmlFor="collection">Category*</label>
									<CustomDropdown
										isLoading={isLoading}
										isShowLabel={false}
										toolTipLength={18}
										items={allCategories}
										selectedItem={selectedSketchResponse?.categoryResponse?.name}
										onItemClick={(value) => onAddListType(value, 'CATEGORY')}
									/>{' '}
									{error.category && <p className="error">{error.category}</p>}
								</div>
							</div>
							<div className="col-md-4 pr-2">
								<div
									className="form-group"
									onClick={() => setSelectedListType('PRODUCT_FITTING_TYPE')}
								>
									<label htmlFor="fitting-type">Fitting type*</label>
									<CustomDropdown
										isLoading={isLoading}
										isShowLabel={false}
										toolTipLength={18}
										items={allOtherTags}
										selectedItem={selectedSketchResponse?.fittingTypeTagResponse?.text}
										isAddNewOnInline={true}
										onItemClick={(value) => onAddListType(value, 'PRODUCT_FITTING_TYPE')}
									/>{' '}
									{error.fittingTypeTag && <p className="error">{error.fittingTypeTag}</p>}
								</div>
							</div>
							<div className="col-md-6 pr-2">
								<div
									className="form-group "
									onClick={() => setSelectedListType('PRODUCT_RISE')}
								>
									<label htmlFor="rise">Rise</label>
									<CustomDropdown
										isLoading={isLoading}
										isShowLabel={false}
										items={allOtherTags}
										selectedItem={selectedSketchResponse?.riseTagResponse?.text}
										isAddNewOnInline={true}
										onItemClick={(value) => onAddListType(value, 'PRODUCT_RISE')}
									/>
								</div>
							</div>
							<div className="col-md-6 pr-2">
								<div
									className="form-group "
									onClick={() => setSelectedListType('PRODUCT_LENGTH')}
								>
									<label htmlFor="rise">Length</label>
									<CustomDropdown
										isLoading={isLoading}
										isShowLabel={false}
										items={allOtherTags}
										selectedItem={selectedSketchResponse?.lengthTagResponse?.text}
										isAddNewOnInline={true}
										onItemClick={(value) => onAddListType(value, 'PRODUCT_LENGTH')}
									/>
								</div>
							</div>
							<div className="col-md-4 pr-2">
								<div
									className="form-group no-shadow-react-select"
									onClick={() => setSelectedListType('SKETCH_TAGS')}
								>
									<label htmlFor="inspired">Tag</label>
									<CreatableSelect
										isMulti
										value={selectedSketchResponse?.tagResponseList?.map((tag) => ({
											value: tag.id,
											label: tag.text
										}))}
										onChange={onTagsChange}
										options={allTags}
									/>
								</div>
							</div>
							<div className="col-md-4 pr-2">
								<div className="form-group">
									<label htmlFor="collection">Inspired from</label>
									<input
										type="text"
										className="w-100"
										onChange={(e) =>
											setSelectedSketchResponse({
												...selectedSketchResponse,
												inspiredFrom: e.target.value
											})
										}
										value={selectedSketchResponse?.inspiredFrom}
									/>
								</div>
							</div>
							<div className="col-md-4 pr-2">
								<div className="form-group">
									<label htmlFor="collection">Remarks</label>
									<input
										type="text"
										className="w-100"
										onChange={(e) =>
											setSelectedSketchResponse({
												...selectedSketchResponse,
												remarks: e.target.value
											})
										}
										value={selectedSketchResponse?.remarks}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="modal-footer pt-0">
					<div className="footer-buttons text-right">
						<button className="button gray-outline size32 ml-2" onClick={onCloseModal}>
							Cancel
						</button>
						<button className="button size32 ml-2" onClick={onSubmit}>
							Submit
						</button>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default AddSketchModal;
